import React, { Component, ReactNode } from 'react'
import { Menu, Button, Icon, Flag, Container } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { RouteComponentProps } from 'react-router-dom'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta, UserInfo, getLocalizedLabel } from '../common'
import logo from '../img/logo.svg'
import { ReactSVG } from 'react-svg'


export const searchTypeOrder = (a:any,b:any) => {
  const ua = a.type.split(':', 1)[0]
  const ub = b.type.split(':', 1)[0]
  const c1 = (a.type.match(/:/g) || []).length
  const c2 = (b.type.match(/:/g) || []).length
  if (ua != ub)
    return ua < ub ? -1 : 1
  else if (c1 !== c2) {
    return  c1 < c2 ? -1 : 1
  }
  else {
    if (!a.params?.order)
      return 1
    else if (!b.params?.order)
      return -1
    else
      return a.params.order < b.params.order ? -1 : b.params.order < a.params.order ? 1 : 0
  }
}

interface TopMenuProps extends WithTranslation, RouteComponentProps {
  meta: Meta,
  http: AxiosInstance,
  nolang?: boolean,
  user: UserInfo|null,
  setUser: (UserInfo) => void
}

interface TopMenuState {
  //user: UserInfo,
  loaded: boolean
}

type MenuItem = {
  key: string,
  label: string,
  path: string
}

class TopMenu extends Component<TopMenuProps, TopMenuState> {

  state = {
    user: {
      firstname: '',
      surname: '',
      username: '',
      authorized: false,
      group: '',
      groups: [],
      config: false,
      files: false
    },
    loaded: false
  }

  //handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  logout () {
    this.props.http.get('logout')
      .then(response => {
          //this.setState({user:{firstname:'', surname: '', username: '', authorized: false, group: '', groups: [], config: false, files: false}, loaded: false})
          this.setState({loaded: false})
          this.props.setUser(null)
      }).catch(err => {
          if (err.response) {
              // UNAUTHORIZED
              if (err.response.status===401) {
                  //this.setState({user: {authorized: false}})
              }
          }
      })
  }

  componentDidUpdate(prevProps: TopMenuProps, prevState: TopMenuState) {
    let { loaded } = this.state
    const state = this.state
    if (prevProps.location.pathname === '/login') {
      loaded = false
    }
    /*if (!loaded && !this.props.user) {
      this.props.http.get('user')
      .then(response => {
          //state.user = response.data.data[0]
          //state.user.authorized = true
          this.props.setUser(response.data.data[0])
          state.loaded = true
          this.setState(state)
      }).catch(err => {
        state.loaded = true
          if (err.response) {
              // UNAUTHORIZED
              if (err.response.status===401) {
                  //this.setState({user: {authorized: false}})
              }
          }
      })
    }*/
  }

  render() {
    const { i18n, meta, location, history, t, user } = this.props
    //const { user } = this.state
    let items : any[] = []
    let subitems : any[] = []
    let activeBase = ''
    let activeSubItem: string|null = ''
    const config = location.pathname.startsWith('/config')

    if (!meta.uis['search']) return(null)

    let directRequest = ''

    if (!config) {
      // first two levels only (user and base type group)
      const uis: any[] = Object.values(meta.uis['search']).sort(searchTypeOrder)
      for (const ui in uis) {
        const i = uis[ui]
        if (!i['_can_read']) continue
        //let i = meta.uis['search'][type]
        const parts = i['type'].split(':')
        const base = parts[1]
        // for global single level types just use the second level ID; otherwise concatenate all parts with underscores
        const key = parts.length === 2 && !parts[0] ? parts[1] : parts.join('_')
        const path = "/search/" + key
        // currently active group
        if (location.pathname === path || location.pathname.startsWith(path+'/')) {
          activeBase = base
          if (location.pathname.startsWith(path+'/')) {
            directRequest = location.pathname.substring(path.length)
          }
          // if the base defines valid form, it becomes also the active subitem
          if (i.params?.search) {
            activeSubItem = path
            sessionStorage.setItem('subitem_search_'+base, path)
            localStorage.setItem('subitem_search_'+base, path)
          }
          /* else if (!activeSubItem) {
            activeSubItem = localStorage.getItem('subitem_search_'+base) || ''
            if (activeSubItem)
              history.push(activeSubItem)
          }
          */
        }
        const label = getLocalizedLabel(i['label'], i18n.language)
        const sublabel = i['params']['sublabel'] ? getLocalizedLabel(i['params']['sublabel'], i18n.language) : null
        // group first level menu items by second level ID
        if (parts.length === 2 && (parts[0]=='' || !items.map(x => x.base).includes(base))) {
          const lastActiveSubItem = sessionStorage.getItem('subitem_search_'+base) || localStorage.getItem('subitem_search_'+base) || path
          items.push({key: key, label: label, path: path, base: base, lastSub: lastActiveSubItem})
        }
        if (parts.length && i.params?.search && !i.params?.hidden) {
          subitems.push({key: key, label: sublabel || label, path: path, base: base})
          /*
          // if the main base does not define a valid form, choose the first subitem as active
          if (!activeSubItem && (path.startsWith(location.pathname) || (!location.pathname.includes('_') && path.startsWith(location.pathname.replace(/\/search\//, '/search/_'))))) {
            activeSubItem = path
            //localStorage.setItem('subitem_search_'+base, path)
          }
          */
        }
      }
    } else {
      items = [
        {key: 'categories', label: t('Categories'), path: '/config/cats/', base: 'cats'},
        {key: 'interfaces', label: t('Interfaces'), path: '/config/uis/', base: 'uis'},
        {key: 'resources', label: t('Resources'), path: '/config/resources/', base: 'resources'},
      ]
      activeBase = location.pathname.split('/')[2]
    }

    // is the last subitem still available? if so, we can make it default
    for (let si of items) {
      if (si.lastSub && subitems.filter(x => x.path===si.lastSub).length && si.lastSub!=si.path) {
        si.path = si.lastSub
      }
    }

    // subitems displayed only for the currently active group
    subitems = subitems.filter(x => x.base===activeBase)

    if (!activeSubItem) {
      activeSubItem = localStorage.getItem('subitem_search_'+activeBase) || null
      const submeta = activeSubItem ? meta.uis['search'][activeSubItem?.replaceAll('_', ':')] : null
      if (!(submeta && submeta['_can_read'])) {
        activeSubItem = ''
      }
      if (!directRequest && activeSubItem) {
        // load last active subitem
        history.push(activeSubItem)
      } else if (subitems.length) {
        // if the main base does not define a valid form, choose the first subitem as active
        activeSubItem = subitems[0].path
        history.push(activeSubItem+directRequest)
      }
    }

    const menuitems = items.map((item, index: number) => (
      <Menu.Item key={item['key']} name={item['key']} active={activeBase===item['base']}>
        <NavLink to={item['path']} style={{color:'black'}}>{item['label']}</NavLink>
      </Menu.Item>
    ))

    const submenuitems = subitems.map((item, index: number) => (
      <Menu.Item key={item['key']} name={item['key']} active={activeSubItem===item['path']} /*location.pathname === item['path'] || location.pathname.startsWith(item['path']+'/')}*/ >
        <NavLink to={item['path']} style={{color:'black'}}>{item['label']}</NavLink>
      </Menu.Item>
    ))

    return (
      <>
      <Container>
      <Menu pointing secondary color="black" stackable style={{marginTop: '60px', marginBottom: '10px'}}>
        {config && 
        <Menu.Item key="search" name="search">
          <NavLink to="/search" style={{color:'black'}}><Icon name="chevron left" title={t('Search')}/></NavLink>
        </Menu.Item> 
        }
        {menuitems}
        {(!config && user?.files) && 
        <Menu.Item key="files" name="files" active={location.pathname === '/files' || location.pathname.startsWith('/files')}>
          <NavLink to="/files/" style={{color:'black'}}><Icon name="database" title={t('Storage')}/></NavLink>
        </Menu.Item> 
        }
        {(!config && user?.config) && 
        <Menu.Item key="config" name="config">
          <NavLink to="/config" style={{color:'black'}}><Icon name="cog" title={t('Configuration')}/></NavLink>
        </Menu.Item> 
        }
        <Menu.Menu position='right'>
          {/*this.props.user ? null :
          <Menu.Item name='user'>
            {user.authorized ? (
            <div>
              <Button compact size='mini' icon labelPosition='right' onClick={() => this.logout()}>
                {user.firstname} {user.surname}
                <Icon name='sign out' />
              </Button>
            </div>
            ) : (
            <div>
              <NavLink to={{ pathname: "/login", state: { from: location } }}>{t('Login')}</NavLink>
            </div>
            )}
          </Menu.Item>
          */}
          {this.props.nolang ? null :
          <Menu.Item name='lang'>
            { i18n.language.startsWith('cs') ? (
              <div><Flag name="uk" style={{cursor:'pointer'}} onClick={() => { i18n.changeLanguage('en')}} /></div>
            ) : (
              <div><Flag name="cz" style={{cursor:'pointer'}} onClick={() => { i18n.changeLanguage('cs')}} /></div>
            ) }
          </Menu.Item>
          }
          <Menu.Item name='logo' className="logo">
            <ReactSVG src={logo}/>
          </Menu.Item>
          </Menu.Menu>
      </Menu>
      </Container>
      { subitems.length > 1 ?
        <Container>
          <Menu tabular attached="top">
            {submenuitems}
          </Menu>
        </Container>
      : null}
      </>
    )
  }
}

export default withTranslation()(TopMenu)